
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/list.htm",
      function () {
        return require("private-next-pages/list.htm/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/list.htm"])
      });
    }
  